module.exports = __webpack_public_path__ + "media/phone.c89db981.mp4";